export const PUBLIC_MOORAGE_CATEGORY = 'public_moorage';
const PUBLIC_MOORAGE_BADGE_LABEL = 'Public Moorage';

/**
 * Public moorages are info-only public listings. Category values can describe
 * the moorage type, but should not opt a normal listing into check-in behavior.
 */
export const isPublicMoorageListing = publicData =>
  Boolean(publicData?.infoOnly === true);

const formatMoorageTypeLabel = type => {
  if (!type) {
    return '';
  }

  return String(type)
    .replace(/([A-Z])/g, ' $1')
    .replace(/_/g, ' ')
    .trim()
    .replace(/^\w/, c => c.toUpperCase())
    .toLowerCase()
    .replace(/^\w/, c => c.toUpperCase());
};

export const getMoorageBadgeLabel = publicData => {
  if (publicData?.infoOnly === true) {
    return PUBLIC_MOORAGE_BADGE_LABEL;
  }

  const moorageType =
    publicData?.moorageType ||
    publicData?.type ||
    publicData?.listingType ||
    publicData?.categoryLevel2 ||
    publicData?.category ||
    '';

  return formatMoorageTypeLabel(moorageType);
};
